/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function WandSparklesIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="wand-sparkles"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M13.6 11.075C14.15 10.524 15.043 10.524 15.594 11.075C16.145 11.626 16.145 12.519 15.594 13.069L8.115 20.548C7.565 21.099 6.672 21.099 6.121 20.548C5.57 19.997 5.57 19.104 6.121 18.554L13.6 11.075Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M11.855 12.82L13.849 14.814" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M7.91 3.052A4.485 4.485 0 0 1 3.5 7.462" data-tinysvg-shape="arc" data-tinysvg-arc="3.426 2.977 4.485 4.485 0.949 89.051 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12.321 7.462A4.485 4.485 0 0 1 7.91 3.052" data-tinysvg-shape="arc" data-tinysvg-arc="12.395 2.977 4.485 4.485 90.949 179.051 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3.5 7.462A4.485 4.485 0 0 1 7.91 11.872" data-tinysvg-shape="arc" data-tinysvg-arc="3.426 11.947 4.485 4.485 270.949 359.051 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M7.91 11.872A4.485 4.485 0 0 1 12.321 7.462" data-tinysvg-shape="arc" data-tinysvg-arc="12.395 11.947 4.485 4.485 180.949 269.051 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M19.601 4.687A2.94 2.94 0 0 1 17.187 7.101" data-tinysvg-shape="arc" data-tinysvg-arc="16.701 4.201 2.94 2.94 9.501 80.499 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(80)} data-tinysvg-stroke-width="80" />
          <path d="M22.015 7.101A2.94 2.94 0 0 1 19.601 4.687" data-tinysvg-shape="arc" data-tinysvg-arc="22.5 4.201 2.94 2.94 99.501 170.499 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(80)} data-tinysvg-stroke-width="80" />
          <path d="M17.187 7.101A2.94 2.94 0 0 1 19.601 9.515" data-tinysvg-shape="arc" data-tinysvg-arc="16.701 10 2.94 2.94 279.501 350.499 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(80)} data-tinysvg-stroke-width="80" />
          <path d="M19.601 9.515A2.94 2.94 0 0 1 22.015 7.101" data-tinysvg-shape="arc" data-tinysvg-arc="22.5 10 2.94 2.94 189.501 260.499 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(80)} data-tinysvg-stroke-width="80" />
    </svg>
  )
}
